const SHEET_ID = "1Lb9QEwmF-gKDdLvcgFVM8wVJ1Ol8uTwyKmHiM_FTBJc";
const SHEET_NAME = "hinweise";

const parseSheetDate = (value) => {
  if (!value) return null;

  const raw = String(value).trim();

  // Format: YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month, day] = raw.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  // Format: DD.MM.YYYY
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(raw)) {
    const [day, month, year] = raw.split(".").map(Number);
    return new Date(year, month - 1, day);
  }

  const fallback = new Date(raw);

  return Number.isNaN(fallback.getTime())
    ? null
    : fallback;
};

const isActive = (value) => {
  const normalized = String(value ?? "")
    .trim()
    .toLowerCase();

  return [
    "true",
    "wahr",
    "ja",
    "1",
    "x",
  ].includes(normalized);
};

export const getAnnouncements = async () => {
  try {
    const url =
      `https://opensheet.elk.sh/${SHEET_ID}/${encodeURIComponent(
        SHEET_NAME
      )}`;

    console.log("Lade Hinweise von:", url);

    const response = await fetch(url, {
      cache: "no-store",
    });

    if (!response.ok) {
      const responseText = await response.text();

      throw new Error(
        `Fehler beim Laden der Hinweise: ${response.status} ${responseText}`
      );
    }

    const data = await response.json();

    console.log("Hinweise aus Google Sheet:", data);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return data.filter((item) => {
      if (!isActive(item.aktiv)) {
        return false;
      }

      const startDate = parseSheetDate(item.startdatum);
      const endDate = parseSheetDate(item.enddatum);

      if (!startDate || !endDate) {
        console.warn("Ungültiges Datum:", item);
        return false;
      }

      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      return today >= startDate && today <= endDate;
    });
  } catch (error) {
    console.error(
      "Fehler beim Laden der Hinweise:",
      error
    );

    return [];
  }
};